<div class="front-container">

    <div class="row">
            <img src="assets/ex.png" alt="Easy-Xchange">
            <h1 class="title">Easy-Xchange</h1>
    </div>

    <div class="search-bar">
        <mat-tab-group>
            <mat-tab label="Find Items">
                <app-input-details [selectedIndex]="0"></app-input-details>
            </mat-tab>
            <mat-tab label="Find Homes">
                <app-input-details [selectedIndex]="1"></app-input-details>
            </mat-tab>
        </mat-tab-group>
    </div>
    
</div>

<app-donate></app-donate>